<div class="flex items-center gap-1 p-4">
  <h1 class="title mt-0 mb-1">{{ 'dashboard.title' | translate }}</h1>
  <app-wiki-help-link path="/dashboard-overview"></app-wiki-help-link>
</div>
<iframe id="dashboard"
        src="https://telemann.matomo.cloud/index.php?module=Widgetize&action=iframe&moduleToWidgetize=Dashboard&actionToWidgetize=index&idSite=1&period=week&date=yesterday&token_auth=617a21dc56709a4559411f6b4ae03513"
        height="100%" width="100%"></iframe>
